const DATADOG_LOGS_BASE_URL = 'https://vwfs-du-central.datadoghq.eu/logs';
const DATADOG_LOOKBACK_MS = 30 * 24 * 60 * 60 * 1000;

export function buildDatadogLogsUrl(requestId: string): string {
  const toTs = Date.now();
  const fromTs = toTs - DATADOG_LOOKBACK_MS;
  const query = new URLSearchParams({
    query: `@taskId:${requestId}`,
    from_ts: String(fromTs),
    to_ts: String(toTs),
  });

  return `${DATADOG_LOGS_BASE_URL}?${query.toString()}`;
}

export function openDatadogLogs(requestId: string): void {
  window.open(buildDatadogLogsUrl(requestId), '_blank', 'noopener,noreferrer');
}
